import { render, staticRenderFns } from "./dropfile.vue?vue&type=template&id=1efe6a7e&"
import script from "./dropfile.vue?vue&type=script&lang=js&"
export * from "./dropfile.vue?vue&type=script&lang=js&"
import style0 from "./dropfile.vue?vue&type=style&index=0&id=1efe6a7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports